





































































































import { defineComponent, reactive, toRefs, onMounted, ref } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http"
import AlertArea from "../../components/AlertArea.vue"
import TeacherMainteTab from "../../components/TeacherMainteTab.vue"
import { BTable, BModal } from 'bootstrap-vue';
import { SearchCondition, TeacherAccessibleStudentPage } from "../../modules/teacher/TeacherAccessibleStudentPageList"

export interface Data {
  tabNo: number
  condition: SearchCondition
  teacherAccessibleStudentPages: TeacherAccessibleStudentPage[]
  fields: any[]
  perPage: number
  totalCount: number
  isShowPagination: boolean
  isAllDeleteChecked: boolean
  errors: string[]
  modalTeacherAccessibleStudentPage: TeacherAccessibleStudentPage
}

export default defineComponent({
  components: {
    "teacher-mainte-tab": TeacherMainteTab,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const tableRef = ref<InstanceType<typeof BTable>>();
    const modalRoomNameRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 2,
      condition: new SearchCondition(),
      teacherAccessibleStudentPages: [],
      fields: [
        {key: "login_id", label: "ログインID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "user_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'},
        {key: "room_name_cache", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "delete", label: "削除", class: 'text-center'},
      ],
      perPage: 100,
      totalCount: 0,
      isShowPagination: false,
      isAllDeleteChecked: false,
      errors: [],
      modalTeacherAccessibleStudentPage: null,
    });

    /******************************
     * 全件選択
     ******************************/

    const allSelectChanged = (isChecked: boolean) => {
      tableRef.value.computedItems.forEach((x: any) => x.is_checked = isChecked);
    };

    /******************************
     * 削除
     ******************************/

    const deleteMst = async (): Promise<void> => {

      if(state.teacherAccessibleStudentPages.filter(x => x.is_checked).length == 0){
        alert("削除対象が選択されていません。");
        return;
      }

      if(!window.confirm("削除を実行します。よろしいですか？")){
        return;
      }
      
      context.root.$store.dispatch("showOverlay");

      const delete_ids: number[] = state.teacherAccessibleStudentPages.filter(x => x.is_checked).map(x => x.id);

      await http.post(`/api/teacher/teacher_accessible_student_page_list/destroy`, {ids: delete_ids}).then(response => {
        alert(`削除処理が完了しました。`);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索ボタンクリック
     ******************************/

    const searchButtonClick = async () => {
      state.condition.page = 1;
      await search();
    }

    /******************************
     * ページング
     ******************************/

    const changePage = async (page: number) => {
      state.condition.page = page;
      await search();
    };

    /******************************
     * Excelダウンロード
     ******************************/

    const download = async () => {

      context.root.$store.dispatch("showOverlay", "ダウンロード中... しばらくお待ちください。");

      await http.get(`/api/teacher/teacher_accessible_student_page_list/download?${Common.BuildQuery(state.condition, 'search_condition')}`, {responseType: 'arraybuffer'}).then(async response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `成績閲覧マスタ.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          alert(`エクセルのダウンロードに失敗しました。\n${errorData.errors[0]}`);
        }else{
          alert("エクセルのダウンロードに失敗しました。");
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/teacher_accessible_student_page_list?${Common.BuildQuery(state.condition, 'search_condition')}`).then(response => {
        state.teacherAccessibleStudentPages = response.data.teacher_accessible_student_pages.map((x: any) => new TeacherAccessibleStudentPage(x)); 
        state.totalCount = state.teacherAccessibleStudentPages.length == 0 ? 0 : response.data.teacher_accessible_student_pages[0].full_count;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    };


    const showRoomNameModal = (teacherAccessibleStudentPage: TeacherAccessibleStudentPage) => {
      state.modalTeacherAccessibleStudentPage = teacherAccessibleStudentPage;
      context.root.$nextTick(() => {
        modalRoomNameRef.value.show();
      });
    }

    const updateAccessibleRooms = async () => {
      if(!window.confirm("閲覧可能教室を更新します。よろしいですか？")){
        return;
      }

      const param = {
        id: state.modalTeacherAccessibleStudentPage.id,
        grade: state.modalTeacherAccessibleStudentPage.grade,
        room_name: state.modalTeacherAccessibleStudentPage.room_name,
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/teacher_accessible_student_page_list/update`, param).then(response => {
        alert("処理が完了しました。");
        state.modalTeacherAccessibleStudentPage.room_name_cache = state.modalTeacherAccessibleStudentPage.room_name;
        modalRoomNameRef.value.hide();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      await search();
      state.isShowPagination = true;
    });

    return {
      ...toRefs(state),
      tableRef,
      modalRoomNameRef,
      searchButtonClick,
      clearCondition,
      allSelectChanged,
      deleteMst,
      changePage,
      download,
      showRoomNameModal,
      updateAccessibleRooms,
    };
  }
});
